import { useMemo } from "react"

import dayjs from "dayjs"

import usePreprocessData from "../../hooks/usePreprocessData"

const KEY_FORMAT = "YYYY/MM/DD"

export default () => {
    const preprocessData = usePreprocessData()

    return useMemo<Record<string, [Date, number][]>>(() => {
        const aggregatedPerSpecies = preprocessData("feeding").reduce<Record<string, Record<string, number>>>(
            (acc, observation) => {
                const key = observation.timestamp.format(KEY_FORMAT)
                observation.items.forEach(({ species, count }) => {
                    acc[species] =
                        species in acc
                            ? {
                                  ...acc[species],
                                  [key]: (acc[species][key] || 0) + count,
                              }
                            : { [key]: count }
                })
                return acc
            },
            {},
        )

        return Object.entries(aggregatedPerSpecies).reduce(
            (acc, [species, series]) => ({
                ...acc,
                [species]: Object.entries(series).map(([key, value]) => [dayjs(key, KEY_FORMAT).toDate(), value]),
            }),
            {},
        )
    }, [preprocessData])
}
